import React from 'react';

// const ProjectRight = ({ project }) => {
   const ProjectRight = () => {

//   if (!project) return <div className="project-right">Select a project to see details.</div>;

  return (
 <>
  <style
    dangerouslySetInnerHTML={{
      __html:
        "\n    .quote-banner {\n     background: linear-gradient(to left, #000814, #0b1234, #2d3f7a);\n      color: white;\n      padding: 20px 30px;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n     /*flex-wrap: wrap;*/\n    }\n    .quote-banner h5 {\n      margin: 0;\n      font-weight: 700;\n      font-style: italic;\n    }\n    .quote-banner .btn {\n      font-weight: 600;\n      text-transform: uppercase;\n      margin: 5px;\n    }\n\n    .composition-card {\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n  }\n\n  .composition-header {\n    background: #0b1234; /* dark navy (like your image) */\n    color: #fff;\n    font-weight: 700;\n    padding: 12px 20px;\n    font-size: 1rem;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n  }\n\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ccc !important;\n    vertical-align: middle;\n  }\n\n  .table th {\n    width: 30%;\n    font-weight: 600;\n  }\n\n    .table-container {\n      background: #fff;\n      color: #000;\n      border-radius: 6px;\n      overflow: hidden;\n    }\n\n    .table {\n      margin: 0;\n      border-collapse: separate;\n      border-spacing: 0;\n      border-radius: 10px;\n      overflow: hidden;\n    }\n   .tbl_thred th{\n      background-color: #0b1234;\n      color: #fff;\n    }\n    \n  "
    }}
  />
  <main>
    {/* breadcrumb area start */}
    <section className="ca-breadcrumb-area cream-bg-3 p-relative z-index-1 fix">
      <div className="ca-breadcrumb-shape p-absolute bre-sh-1">
        <img
          src="/img/shape/breadcrumn-shape.webp"
          alt=""
        />
      </div>
      <div className="ca-breadcrumb-shape p-absolute bre-sh-2">
        <img
          src="/img/shape/ca-line-shape.webp"
          alt=""
        />
      </div>
      <div className="container">
        <div className="ca-breadcrumb-content text-center">
          <h2 className="ca-breadcrumb-title fnw-600">U Bend</h2>
          <div className="it-breadcum-link">
            <a href="/">Home</a>
            <span>
              <i className="fa-solid fa-angle-right" />
            </span>
            <a href="/projects">Project</a>
            <span>
              <i className="fa-solid fa-angle-right" />
            </span>
            <a className="active" href="#">
              U Bend
            </a>
          </div>
        </div>
      </div>
    </section>
    {/* breadcrumb area end */}
    {/* project left */}
    <div className="ca-service-lft-area pt-100 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mb-30">
            <div className="ca-project-content-area">
              <div className="ca-pro-thumb-content">
                <h2 className="ca-project-thumb-title theme-black-3 fnw-600 ca-text-cap">
                  U Bend
                </h2>
                <p className="pt-16 pb-40">
                  We provide a full spectrum of logistics &amp; transport
                  services designed to meet the specific needs businesses <br />{" "}
                  in various industries. Our Freight Forwarding Services utilize
                  a vast network of carriers to ensure your <br />
                  international shipments are managed efficiently and
                  cost-effectively.
                </p>
                <div className="ca-servic-thumb br-7">
                  <img
                    className="w-100"
                    src="/img/portfolio/ca-pro-thumb1.1.webp"
                    alt=""
                  />
                </div>
                <br />
                <h3 className="ca-project-thumb-title-2 theme-black-3 fnw-600 ca-text-cap">
                  Consolidation and Deconsolidation Services
                </h3>
                <p className="pt-16">
                  Our Warehousing Solutions offer secure, climate-controlled
                  storage with advanced inventory tracking to <br /> keep your
                  goods safe &amp; easily accessible. We excel in Customs
                  Clearance, simplifying the complexities of <br />{" "}
                  international trade and ensuring your shipments comply with
                  all regulations.
                </p>
                {/*  <p class="pt-20">Our Global Shipping Services guarantee that your products reach global markets on
                  time, leveraging our <br> strategic partnerships and logistical expertise. For domestic
                  logistics, our Domestic Transport Solutions <br>provide reliable, flexible delivery options
                  across the country.</p> */}
                {/* <div class="row">
                  <div class="col-lg-6">
                     <div class="ca-projrct-iner-box cream-bg-3 br-7">
                        <h4 class="ca-title fnw-600 theme-black-3 pb-16 ca-text-cap">Reverse Logistics Management
                        </h4>
                        <p>We optimize every aspect of your supply <br> chain through Supply Chain Management<br>
                           services, from procurement to delivery,<br> enhancing operational efficiency.</p>
                     </div>
                  </div>
                  <div class="col-lg-6">
                     <div class="ca-projrct-iner-box cream-bg-3 br-7">
                        <h4 class="ca-title fnw-600 theme-black-3 pb-16 ca-text-cap">Heavy Lift and Project Cargo
                        </h4>
                        <p>Our E-commerce Logistics Solutions are <br> designed to streamline your online order
                           <br>fulfillment, offering seamless integration <br> with your e-commerce platform
                        </p>
                     </div>
                  </div>
               </div> */}
                <div className="ca-about-item3 cream-bg-3 p-relative">
                  <p>
                    Our Express Delivery Services offer fast and reliable
                    shipping options to meet urgent delivery <br /> needs, and
                    our Inventory Management solutions help you maintain
                    accurate stock levels, reduce <br /> costs, and improve
                    customer satisfaction. Partner with Cargon for innovative
                    and tailored
                  </p>
                </div>
                <div className="ca-ab-item-check ca-ab-item-check-2 caborder-top">
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        Secure Warehousing
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        Customs Brokerage
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        E-commerce Fulfillment
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        Heavy Lift and Project Cargo
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        Rapid Express Delivery
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        Inventory Optimization
                      </h4>
                    </div>
                  </div>
                </div>
                {/* quote-banner */}
                {/*  <div class="container my-4">
                 <div class="quote-banner">
                   <h5>GET YOUR INSTANT QUOTE NOW – FAST DELIVERY & BEST PRICE GUARANTEED!</h5>
                   <div>
                     <a href="#contact" class="btn btn-primary">Contact Us</a>
                   </div>
                 </div>
               </div>
 */}
                <h3 className="ca-project-thumb-title-2 theme-black-3 fnw-600 ca-text-cap">
                  Domestic Freight Transport
                </h3>
                <p className="pt-16">
                  Our expertise in Customs Clearance navigates the complexities
                  of global trade regulations, ensuring your
                  <br /> shipments comply with all necessary requirements and
                  minimizing delays. Our Global Shipping Services <br />
                  connect you to international markets, utilizing optimized
                  routes and reliable carriers to enhance
                </p>
              </div>
            </div>
            {/* Chemical Composition Table */}
            <div className="container my-4">
              <div className="composition-card">
                <div className="composition-header">
                  Copper Medical Grade Fitting Chemical Composition
                </div>
                <table className="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">CU%</th>
                      <td>99.90%</td>
                    </tr>
                    <tr>
                      <th scope="row">P%</th>
                      <td>0.015% To 0.04%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="container table-container mt-4">
              <table className="table table-bordered text-center align-middle table-bordered_tbl">
                <thead className="tbl_thred">
                  <tr>
                    <th>Fitting Type</th>
                    <th>Nominal Size</th>
                    <th>Outer Diameter (mm)</th>
                    <th>Wall Thickness (mm)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan={4}>Copper Elbow 90°</td>
                    <td>10mm</td>
                    <td>10</td>
                    <td>0.8 – 1.0</td>
                  </tr>
                  <tr>
                    <td>12mm</td>
                    <td>12</td>
                    <td>0.8 – 1.0</td>
                  </tr>
                  <tr>
                    <td>15mm</td>
                    <td>15</td>
                    <td>0.9 – 1.2</td>
                  </tr>
                  <tr>
                    <td>22mm</td>
                    <td>22</td>
                    <td>1.0 – 1.5</td>
                  </tr>
                  <tr>
                    <td rowSpan={3}>Copper Tee</td>
                    <td>12mm</td>
                    <td>12</td>
                    <td>0.8 – 1.0</td>
                  </tr>
                  <tr>
                    <td>15mm</td>
                    <td>15</td>
                    <td>0.9 – 1.2</td>
                  </tr>
                  <tr>
                    <td>22mm</td>
                    <td>22</td>
                    <td>1.0 – 1.5</td>
                  </tr>
                  <tr>
                    <td rowSpan={3}>Copper Coupling</td>
                    <td>10mm</td>
                    <td>10</td>
                    <td>0.8 – 1.0</td>
                  </tr>
                  <tr>
                    <td>15mm</td>
                    <td>15</td>
                    <td>0.9 – 1.2</td>
                  </tr>
                  <tr>
                    <td>22mm</td>
                    <td>22</td>
                    <td>1.0 – 1.5</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-lg-4 mb-30">
            {/* sidebar area */}
            <div className="ca-sidebar-area ml-50">
              {/* search */}
              {/* <div class="ca-search ca-padding cream-bg-3 br-7 mb-30">
               <h4 class="ca-title fnw-600 theme-black-3 pb-16">Search</h4>
               <div class="ca-search-box p-relative z-index-1">
                  <input type="text" placeholder="Search..">
                  <div class="ca-sea-icon">
                     <span><i class="fa-solid fa-magnifying-glass"></i></span>
                  </div>
               </div>
            </div> */}
              {/* popular Tags */}
              {/*  <div class="ca-tags ca-padding cream-bg-3 br-7 mb-30">
               <h4 class="ca-title fnw-600 theme-black-3 pb-16">Popular Tags</h4>
               <div class="ca-tags-list">
                  <ul>
                     <li><a href="#">Warehousing</a></li>
                     <li><a href="#">Domestic Transport</a></li>
                     <li><a href="#">Efficient Logistics</a></li>
                     <li><a href="#">Project Cargo</a></li>
                     <li><a href="#">Cold Chain</a></li>
                     <li><a href="#">Express Delivery</a></li>
                  </ul>
               </div>
            </div> */}
              {/* phone us */}
              <div className="ca-servic-list ca-padding cream-bg-3 br-7 mb-30">
                <h4 className="ca-title ca-servic-list-title fnw-600 theme-black-3 pb-24">
                  Contact With Us
                </h4>
                <div className="ca-ph-content">
                  <div className="ca-ph-ic">
                    <span>
                      <img
                        src="/img/icon/ca-ser-phone.svg"
                        alt=""
                      />
                    </span>
                  </div>
                  <div className="ca-ph-title">
                    <h4 className="ph-title">
                      <a href="tel:1234567890">+123 456 7890</a>
                    </h4>
                  </div>
                </div>
              </div>
              {/* sidebar contact */}
              <div className="ca-search ca-padding cream-bg-3 br-7 mb-30">
                <h4 className="ca-title fnw-600 theme-black-3 pb-24">
                  Get A Free Quote
                </h4>
                <div className="ca-sidebar-form">
                  <form action="#">
                    <input type="text" placeholder="Your Name" />
                    <input type="email" placeholder="Email Address" />
                    <input type="tel" placeholder="Phone Number" />
                    <textarea
                      name="message"
                      id="message"
                      rows={10}
                      cols={4}
                      placeholder="Your Message"
                      defaultValue={""}
                    />
                  </form>
                  <div className="ca-sidebar-form-btn text-end">
                    <a
                      href="#"
                      className="ca-btn-primary-3 theme-bg-3 text-white br-50"
                    >
                      Send Now{" "}
                      <span>
                        <i className="fa-solid fa-angle-right" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              {/* Follow Us */}
              <div className="ca-search ca-padding cream-bg-3 br-7 mb-30">
                <h4 className="ca-title fnw-600 theme-black-3 pb-24">
                  Follow Us
                </h4>
                <div className="ca-footer-social ca-footer-social-3">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-instagram" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-linkedin-in" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-x-twitter" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="ca-more-section pb-70">
      <div className="container">
        {/* <h2 class="ca-more-title theme-black-3 fnw-600 text-center mb-60">More Projects</h2>
   <div class="row">
      <div class="col-lg-4 col-md-6"> */}
        {/* single-portfolio-item */}
        {/* <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/img/portfolio/portfolio-sm-1.4.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div>
      </div>
      <div class="col-lg-4 col-md-6"> */}
        {/* single-portfolio-item */}
        {/* <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/img/portfolio/portfolio-sm-1.5.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div>
      </div>
      <div class="col-lg-4 col-md-6"> */}
        {/* single-portfolio-item */}
        {/*  <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/img/portfolio/portfolio-sm-1.6.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div> */}
        {/* </div>
   </div>
 */}
      </div>
    </div>
  </main>
</>

);
};

export default ProjectRight;
